module.exports = __webpack_public_path__ + "img/poster_content.ee97ebf2.png";